import { PlanTier } from './plans';

// Subscription statuses
export const SUBSCRIPTION_STATUS_ACTIVE = 'active';
export const SUBSCRIPTION_STATUS_CANCELED = 'canceled';
export const SUBSCRIPTION_STATUS_DELINQUENT = 'past_due';
export const SUBSCRIPTION_STATUS_TRIALING = 'trialing';
export const SUBSCRIPTION_STATUS_INCOMPLETE = 'incomplete';
export const SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED = 'incomplete_expired';

// Trial statuses
export const TRIAL_STATUS_ACTIVE = 'trialing';
export const TRIAL_STATUS_ENDED = 'post_trial';
export const TRIAL_STATUS_EXPIRED = 'expired';

// Trial Package Ids
export const DEPRECATED_BOOST_TRIAL_PACKAGE = 0;
export const EB_14_DAY_TRIAL_100_PACKAGE = 1;
export const EB_60_DAY_TRIAL_UNLIM_PACKAGE = 2;
export const EB_14_DAY_TRIAL_250_PACKAGE = 3;
export const EB_14_DAY_TRIAL_UNLIM_PACKAGE = 4;

export const TRIAL_PACKAGE_ID_VALUES = {
    DEPRECATED_BOOST_TRIAL_PACKAGE,
    EB_14_DAY_TRIAL_100_PACKAGE,
    EB_60_DAY_TRIAL_UNLIM_PACKAGE,
    EB_14_DAY_TRIAL_250_PACKAGE,
    EB_14_DAY_TRIAL_UNLIM_PACKAGE,
} as const;

export const STANDARD_TRIAL_DURATION_DAYS = 14;

export const VALID_14_DAY_TRIALS = [
    EB_14_DAY_TRIAL_100_PACKAGE,
    EB_14_DAY_TRIAL_250_PACKAGE,
    EB_14_DAY_TRIAL_UNLIM_PACKAGE,
];

// Plan IDs
export const PRO_100 = 'pro-100';
export const PRO_250 = 'pro-250';
export const PRO_UNLIMITED = 'pro-unlimited';
export const TRIAL = 'trial';
export const FLEX = 'flex';

// Plan names
export const DEPRECATED_BOOST_PLAN_NAME = 'Boost';
export const PRO_100_PLAN_NAME = 'Pro 100';
export const PRO_250_PLAN_NAME = 'Pro 250';
export const PRO_UNLIMITED_PLAN_NAME = 'Pro Unlimited';
export const TRIAL_PLAN_NAME = 'Pro 100 Trial';
export const PRO_250_TRIAL_PLAN_NAME = 'Pro 250 Trial';
export const PRO_UNLIMITED_TRIAL_PLAN_NAME = 'Pro Unlimited Trial';
export const FLEX_PLAN_NAME = 'Flex';
export const NPO_PRO_100_PLAN_NAME = 'NPO Pro 100';
export const NPO_PRO_250_PLAN_NAME = 'NPO Pro 250';
export const NPO_PRO_UNLIMITED_PLAN_NAME = 'NPO Pro Unlimited';
export const PRO_2K_PLAN_NAME = 'Pro 2K';
export const PRO_6K_PLAN_NAME = 'Pro 6K';
export const PRO_10K_PLAN_NAME = 'Pro 10K';
export const NPO_PRO_2K_PLAN_NAME = 'NPO Pro 2K';
export const NPO_PRO_6K_PLAN_NAME = 'NPO Pro 6K';
export const NPO_PRO_10K_PLAN_NAME = 'NPO Pro 10K';

// Plan Tiers
export const DEPRECATED_BOOST_PLAN = 'DEPRECATED_BOOST_PLAN';
export const LITE = 'LITE';
export const CORE = 'CORE';
export const PRO = 'PRO';
export const ADMIN_LITE = 'ADMIN_LITE';
export const ADMIN_CORE = 'ADMIN_CORE';
export const ADMIN_PRO = 'ADMIN_PRO';
export const MIGRATION_PRO = 'MIGRATION_PRO';
export const NPO_LITE = 'NPO_LITE';
export const NPO_CORE = 'NPO_CORE';
export const NPO_PRO = 'NPO_PRO';

export const PLAN_TIER_VALUES = {
    LITE,
    CORE,
    PRO,
    ADMIN_LITE,
    ADMIN_CORE,
    ADMIN_PRO,
    MIGRATION_PRO,
    NPO_LITE,
    NPO_CORE,
    NPO_PRO,
    DEPRECATED_BOOST_PLAN,
} as const;

export const ADMIN_PLANS: PlanTier[] = [ADMIN_LITE, ADMIN_CORE, ADMIN_PRO];
export const NPO_PLANS: PlanTier[] = [NPO_LITE, NPO_CORE, NPO_PRO];
export const REGULAR_PLANS: PlanTier[] = [LITE, CORE, PRO];

// Listing Fee Plan Names
export const FREE_LISTING_FEE_PLAN_NAME = 'Flex 25';
export const LITE_LISTING_FEE_PLAN_NAME = 'Flex 100';
export const CORE_LISTING_FEE_PLAN_NAME = 'Flex 250';
export const PRO_LISTING_FEE_PLAN_NAME = 'Flex Unlimited';

// FLEX
export const FLEX_CAMPAIGN_DAILY_LIMIT = 250;
export const FLEX_FREE_TIER_CAPACITY = 25;

// PRO capacity maxes
export const PRO_100_CAPACITY_MAX = 100;
export const PRO_250_CAPACITY_MAX = 250;

// ticket limits
export const PRO_UNLIMITED_TICKET_LIMIT = 'unlimited';

export const EVENT_CAPACITY_MAX = 16777215; // creating this as a constant here because we need it for the fe. if this changes in the future, we have a single place to update it

// FLEX CAPACITIES
export const FLEX_25_CAPACITY = 25;
export const FLEX_100_CAPACITY = 100;
export const FLEX_250_CAPACITY = 250;
export const UNLIMITED_CAPACITY = 16777215;

// Campaign daily limits
export const PRO_100_CAMPAIGN_DAILY_LIMIT = 2000;
export const PRO_250_CAMPAIGN_DAILY_LIMIT = 6000;
export const PRO_UNLIMITED_CAMPAIGN_DAILY_LIMIT = 10000;

// Boost Migration Constants for use with CurrentPlanCard in creator-home (temporary during Boost --> P&P migration)
export const LITE_PLAN = {
    capacity: '100',
    isActiveTrial: false,
    isCancelling: false,
};

export const CORE_PLAN = {
    capacity: '250',
    isActiveTrial: false,
    isCancelling: false,
};

export const PRO_PLAN = {
    capacity: 'unlimited',
    isActiveTrial: false,
    isCancelling: false,
};

// Permissions (to match permissions/constants/features.py and permissions/constants/permissions.py in @eventbrite/permissions_library)
export const PERMISSION_ORGANIZATION_BILLING_PLAN_READ =
    'organization.billing.plan:read';
export const PERMISSION_ORGANIZATION_BILLING_PLAN_MANAGE =
    'organization.billing.plan:manage';
